const accordions = document.querySelectorAll('.m-accordion');

const classes = {
  button: 'm-accordion__button',
  item: 'm-accordion__item',
  itemOpen: 'm-accordion__item--open',
  icon: 'm-accordion__item-header-icon',
  content: 'm-accordion__content',
};

const accordionOpenItem = (item, icon, content, contentHeight) => {
  item.classList.add(`.${classes.itemOpen}`);
  icon.setAttribute('data-accordion-button-icon', 'open');
  content.setAttribute('data-accordion-content', 'open');
  content.style.height = `${contentHeight}px`; // eslint-disable-line
};

const accordionCloseItem = (item, icon, content) => {
  item.classList.remove(`.${classes.itemOpen}`);
  icon.setAttribute('data-accordion-button-icon', 'closed');
  content.setAttribute('data-accordion-content', 'closed');
  content.style.height = '0'; // eslint-disable-line
};

const accordionCloseAll = (accordion) => {
  const accordionItems = accordion.querySelectorAll(`.${classes.item}`);

  accordionItems.forEach((item) => {
    const icon = item.querySelector(`.${classes.icon}`);
    const content = item.querySelector(`.${classes.content}`);

    item.classList.remove(`.${classes.itemOpen}`);
    content.setAttribute('data-accordion-content', 'closed');
    content.style.height = '0';
    icon.setAttribute('data-accordion-button-icon', 'closed');
  });
};

accordions.forEach((accordion) => {
  const accordionItems = accordion.querySelectorAll(`.${classes.item}`);

  accordionItems.forEach((item) => {
    const button = item.querySelector(`.${classes.button}`);
    const icon = item.querySelector(`.${classes.icon}`);
    const content = item.querySelector(`.${classes.content}`);

    // set height on resize
    window.addEventListener('resize', () => {
      if (content.getAttribute('data-accordion-content') === 'open') {
        content.style.height = 'auto';

        const contentHeight = content.scrollHeight;
        content.style.height = `${contentHeight}px`;
      }
    });

    // open and close content
    button.addEventListener('click', () => {
      if (content.getAttribute('data-accordion-content') !== 'open') {
        const contentHeight = content.scrollHeight;

        accordionCloseAll(accordion);
        accordionOpenItem(item, icon, content, contentHeight);
      } else {
        accordionCloseItem(item, icon, content);
      }
    });
  });
});
